<template lang="pug">
  .main-container
    .m-top-4.m-bottom-4.row.width-100.middle.folder-information
      img.school-avatar.m-right-1(:src='schoolGroupVO.currentSchool.avatar' v-if='schoolGroupVO.currentSchool.avatar' width='28px' height='28px')
      simple-svg.dark-gray-icon.m-right-1(v-else :filepath='schoolIcon' :width='"25px"' :height='"25px"')
      router-link.text-normal.m-right-05(:to='{name: routes.school}') {{ selectedSchool.name }}
      simple-svg.dark-gray-icon.m-right-05(:filepath='rightArrowIcon' :width='"16px"' :height='"16px"')
      .text-normal.blue.bold {{ isTeacher ? $t('team.seeTeam') : $t('team.manageTeam') }}
    users-list.m-bottom-10(ref='list')
    invite-users-modal(v-if='showInviteUsersModal' @invitedUsers='reload')
</template>

<script>
import rightArrowIcon from '@/assets/ic_chevron-right.svg'
import schoolIcon from '@/assets/ic_school.svg'
import UsersList from '@/components/Team/UsersList'
import userRole from '../mixins/userRole'
import InviteUsersModal from '@/components/Modals/InviteUsersModal'
import { mapActions, mapState } from 'vuex'
import { routes } from '../router'

export default {
  mixins: [userRole],
  components: { UsersList, InviteUsersModal },
  data() {
    return {
      schoolIcon,
      rightArrowIcon,
      routes
    }
  },
  async created() {
    await this.hydrateProfile()
    await this.hydrateSchoolInfo(this.$route.params.schoolId)
  },
  computed: {
    ...mapState({
      showInviteUsersModal: state => state.behavior.inviteUsersModal.show,
      schoolGroupVO: state => state.profile.userProfile.schoolGroupVO,
      selectedSchool: state => state.profile.selectedSchool
    }),
    toastStyles() {
      return {
        width: '100%',
        display: 'flex',
        left: '0',
        'justify-content': 'center'
      }
    }
  },
  methods: {
    ...mapActions([
      'showElement',
      'hideElement',
      'hydrateProfile',
      'hydrateSchoolInfo'
    ]),
    reload() {
      this.$refs.list.reloadPage(0)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/variables/colors';
@import '../scss/variables/sizes';

.main-container{
  max-width: $content-size;
  margin: 0 auto;
}

.school-avatar{
  border: 1px solid $gray;
  border-radius: 50%;
}

</style>
